export default "__VITE_ASSET__BdCSWB9p__"